import { MessageSquareText, ClipboardCheck, Wrench, BadgeCheck } from "lucide-react";
import { Reveal, SectionHeading } from "./shared";

const STEPS = [
  { icon: MessageSquareText, title: "Tell Us the Issue", desc: "WhatsApp the device model and symptoms — a photo of any error message helps." },
  { icon: ClipboardCheck, title: "Free Diagnostic & Quote", desc: "AFZ reviews the problem and advises the next step. Transparent quotation, no hidden surcharges." },
  { icon: Wrench, title: "Expert Repair", desc: "Diagnosis, repair, setup or upgrade carried out as agreed — component-level, clean repaste." },
  { icon: BadgeCheck, title: "Tested & Handed Over", desc: "Rigorous 24-point quality test before handover, covered by a 90-day warranty." },
];

export const Process = () => (
  <section id="process" data-testid="process-section" className="relative py-24 sm:py-32 bg-void">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="How AFZ Works"
        title="Simple support from first message"
        accent="to final setup."
      />
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {STEPS.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.1}>
            <div data-testid={`process-step-${i + 1}`} className="relative group h-full bg-card/80 border border-slate-800 rounded-2xl p-6 hover:border-brand-cyan/50 transition-all duration-300 hover:shadow-[0_0_30px_rgba(34,211,238,0.12)]">
              {i < 3 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-gradient-to-r from-brand-lime/60 to-transparent z-10" />
              )}
              <span className="font-display text-5xl font-black text-white/10 group-hover:text-brand-lime/25 transition-colors leading-none">
                0{i + 1}
              </span>
              <div className="mt-4 w-12 h-12 rounded-full border-2 border-brand-lime/60 bg-brand-lime/10 flex items-center justify-center text-brand-lime shadow-[0_0_18px_rgba(170,255,0,0.25)]">
                <s.icon className="w-5 h-5" />
              </div>
              <h3 className="mt-4 font-display text-xl font-bold uppercase text-white">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
